module.exports = __webpack_public_path__ + "static/zurich_w-2226d749c47974f262bbee3bd9f41461.svg";